import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Image, Modal, Row } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import Zoom from "react-medium-image-zoom";
import emptyPad from "assets/emptyPad.png";
import { VectorPen } from "react-bootstrap-icons";

const Signature = ({ value, setValue, header = "Signature Pad" }) => {
  // states
  const [openPad, setOpenPad] = useState(false);
  const ref = useRef(null);

  // functions
  const clear = () => {
    ref.current.clear();
  };

  const confirm = () => {
    if (ref.current.isEmpty()) {
      setValue(null);
    } else {
      setValue(ref.current.toDataURL());
    }
    setOpenPad(false);
  };

  // effects
  useEffect(() => {
    if (ref.current && value) ref.current.fromDataURL(value);
  }, [ref.current]);

  return (
    <React.Fragment>
      <Row>
        <Col sm={4}>
          <Button
            onClick={() => setOpenPad(true)}
            variant="outline-dark"
            className="rounded-circle"
          >
            <VectorPen  size={16}/>
          </Button>
        </Col>
        <Col sm={8}>
          <Zoom>
            <Image src={value || emptyPad} className="w-100" />
          </Zoom>
        </Col>
      </Row>
      <Modal
        show={openPad}
        onHide={() => setOpenPad(false)}
        size="lg"
        contentClassName="shadow-lg"
      >
        <Modal.Header closeButton>{header}</Modal.Header>
        <Modal.Body>
          <SignatureCanvas
            ref={ref}
            canvasProps={{
              className: "sigCanvas w-100 h-50vh border",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={clear} variant="danger">
            Clear
          </Button>
          <Button onClick={confirm} variant="success">
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Signature;
